import React from "react"
import styled from "@emotion/styled"
import { Container, Flex } from "theme-ui"
import PromotionList from "components/lists/programs-events-list"

const Wrapper = styled.div`
    position: relative;
    text-align: center;
    // min-height: 1192px;
    padding-top: 3rem;
    padding-bottom: 3rem;
    background: no-repeat center center;
    background-size: cover;
    background-image: url("/homepage/bg_who_we_are.png");

    & .position {
        justify-content: center;
        & p {
            color: ${(props) => props.theme.colors.secondary};
        }
    }

    & a.explore-more {
        border: 1px solid ${(props) => props.theme.colors.accent_blue};
        border-radius: 2rem;
        margin-top: 2rem;
        padding: 0.7rem 1rem;
        color: ${(props) => props.theme.colors.accent_blue};
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }

    & .promotions-wrapper {
        justify-content: space-between;
        margin: auto;
        flex-direction: row;
        margin-bottom: 2rem;
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[8]}) {
            & p {
                font-size: 22px;
            }
        }

        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[7]}) {
            & p {
                font-size: 20px;
            }
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[3]}) {
            & p {
                font-size: 15px;
            }
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[2]}) {
            & p {
                font-size: 13px;
            }
        }
    }

    & h2 {
        margin-bottom: 0;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        padding: 0 2rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & h2 {
            margin-top: 0;
        }
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & p {
            font-size: 16px;
        }
        & .promotions-wrapper {
            flex-direction: column;
            padding: 0;
        }
    }
`

const SpanTitle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    & span {
        color: ${(props) => props.theme.colors.soft_red};
        font-family: mv-boli;
        text-transform: uppercase;
    }
    & h2 {
        margin-top: 0;
        text-transform: capitalize;
    }
`

function Index({ data }) {
    return (
        <Wrapper>
            <Container>
                <SpanTitle>
                    <h2>Our Programmes and Promotions</h2>
                </SpanTitle>
                <Flex
                    className="position"
                    sx={{
                        margin: "auto",
                    }}
                >
                    <p>{data.description}</p>
                </Flex>
                <div className="promotions-wrapper">
                    <PromotionList data={data} />
                </div>
            </Container>
        </Wrapper>
    )
}

export default Index
